<template lang="pug">
v-dialog(
  v-model="dialog",
  max-width="979",
  persistent,
)
  v-card
    g-btn(icon, small, :style="{ position: 'absolute', right: '5px', top: '5px' }", @click="onCloseBtn")
      v-icon mdi-close
    app-entity(
      modalInstance,
      :parent="entity",
      :path="null",
      :selector="false",
      invert,
      v-bind="$props",
    )
      template(v-for="(_, slot) in $slots")
        template(:slot="slot")
          slot(:name="slot")
    v-card-actions
      v-spacer
      g-btn(@click="onCloseBtn") {{$t('Common.cancel')}}
      g-btn(color="primary", @click="onSaveBtn") {{$t('Common.save')}}
</template>

<script>
import EntityMixin from '@/mixins'
import axios from 'axios'
export default {
  mixins: [EntityMixin],
  props: {
    vertical: {
      type: Boolean,
      default: false,
    },
    dialog: {
      type: Boolean,
      default: true,
    },
    entity: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    async onSaveBtn() {
      try  {
        const { data } = (await axios.post('entity/graph', this.modalInstanceObj));
        this.$store.commit('SET_MODAL_ERRORS', {});
        this.$emit('closeAndLoadItems');
      } catch(e) {
        let { response: { data: { errors } } } = e;
        this.$store.commit('SET_MODAL_ERRORS', errors);
      }
    },
    onCloseBtn() {
      this.$store.commit('SET_MODAL_ERRORS', {});
      this.$emit('close');
    },
  },
  computed: {
    modalInstanceObj() {
      return this.$store.state.modalInstance;
    }
  },
  created() {
    this.$store.commit('SET_MODAL_INSTANCE', { entityState: 4, _Entity: this.entity.name });
  }
}
</script>
